import React, { useEffect, useState, useRef  } from "react";
import api from "~/services/api";

import { Label, Input, Select, TextArea } from "~/componentes/CustomForm";

import { Container } from "./styles";
import { Materialize } from "~/styles/materializeGrid";
import ShowConfirmacao from "~/utils/ShowConfirmacao";
import AtividadesList from "./AtividadesList";

function CreateEditContent({ mountedData }) {
  const [clientes, setClientes] = useState([]);
  const [atividadesProjeto, setAtividadesProjeto] = useState([]);

  const [projetos, setProjetos] = useState([]);
  const [atividades, setAtividades] = useState([]);

  const [idCliente, setIdCliente] = useState(mountedData ? mountedData?.idCliente : 0);
  const [idProjeto, setIdProjeto] = useState(mountedData ? mountedData?.idProjeto : 0);
  const [versao, setVersao] = useState(mountedData ? mountedData?.versao : "v1.0");
  const [dataPrevInicio, setDataPrevInicio] = useState(mountedData ? mountedData?.dataPrevInicio : "");
  const [dataPrevFinal, setDataPrevFinal] = useState(mountedData ? mountedData?.dataPrevFinal : "");
  const [clonaCronograma, setClonaCronograma] = useState("N");

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } }).then((r) => setClientes(r?.data));
  }, []);

  useEffect(() => {
    if (idCliente) {
      idCliente && api.get("/signed/empresa/gestorprojeto/projetos", { params: { ativo: 1, idCliente } }).then((r) => setProjetos(r?.data));
    } else {
      setProjetos([]);
    }
  }, [idCliente]);

  useEffect(() => {
    if (idProjeto) {
      idProjeto && api.get("/signed/empresa/gestorprojeto/projeto", { params: { id: idProjeto, exibeCronograma: "S" } }).then(
        (r) => {
          setDataPrevInicio(r?.data?.previsaoInicio);
          setDataPrevFinal(r?.data?.previsaoEntrega);

          setAtividadesProjeto(r?.data?.atividades);
          setAtividades(r?.data?.atividades);
        }
      );
    } else {
      setAtividadesProjeto([]);
    }
  }, [idProjeto]);

  useEffect(() => {
    if (clonaCronograma == "S") {
      api.get("/signed/empresa/gestorprojeto/projetocronograma/mapeado", { params: { idProjeto } }).then(
        (r) => {
          setDataPrevInicio(r?.data?.dataPrevInicio);
          setDataPrevFinal(r?.data?.dataPrevFinal);
          setVersao(r?.data?.versao);

          setAtividadesProjeto(r?.data?.itens);
          setAtividades(r?.data?.itens);
        }
      );
    } else {
      idProjeto && api.get("/signed/empresa/gestorprojeto/projeto", { params: { id: idProjeto } }).then(
        (r) => {
          setDataPrevInicio(r?.data?.previsaoInicio);
          setDataPrevFinal(r?.data?.previsaoEntrega);

          setAtividadesProjeto(r?.data?.atividades);
          setAtividades(r?.data?.atividades);
        }
      );
    }
  }, [clonaCronograma]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          idCliente,
          idProjeto,
          versao,
          atividades,
          dataPrevInicio,
          dataPrevFinal,
        };

        let response;
        if (mountedData?.id)
          response = await api.put("/signed/empresa/gestorprojeto/projetocronograma", thisData);
        else
          response = await api.post("/signed/empresa/gestorprojeto/projetocronograma", thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }

        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? "atualizar" : "cadastrar"
            } esse Orçamento, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? "atualizar" : "cadastrar"
          } esse Orçamento?`,
        successModal: `Orçamento ${mountedData?.id ? "atualizado" : "cadastrado"
          } com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row no-margin">
          <Label title="Cliente *" className="col s6 m2 l2">
            <Select
              required="true"
              isString
              list={{ list: clientes, value: "id", label: "nomeFantasia" }}
              name="idCliente"
              {...(mountedData ? { disabled:"true" } : {})}
              firstOption
              defaultValue={idCliente}
              onChange={(e) => {
                const v = e.currentTarget.value || 0;
                setIdCliente(v);
              }}
            />
          </Label>
          <Label title="Projeto *" className="col s6 m3 l3">
            <Select
              required="true"
              isString
              {...(mountedData ? { disabled:"true" } : {})}
              list={{ list: projetos, value: "id", label: "titulo" }}
              name="idProjeto"
              firstOption
              defaultValue={mountedData?.idProjeto}
              onChange={(e) => {
                const v = e.currentTarget.value || 0;
                setIdProjeto(v);
              }}
            />
          </Label>
          <Label title="Clona Cronograma *" className="col s6 m2 l2">
            <Select
              required="true"
              isString
              list={{ list: [{ id: "N", titulo: "Não" }, { id: "S", titulo: "Sim" }], value: "id", label: "titulo" }}
              name="clonaCronograma"
              defaultValue={clonaCronograma}
              onChange={(e) => {
                const v = e.currentTarget.value || "N";
                setClonaCronograma(v);
              }}
            />
          </Label>
          <Label title="Versão *" className="col s6 m1 l1">
            <Input 
              {...(mountedData ? { disabled:"true" } : {})} 
              name="versao" 
              required="true" 
              value={versao} 
              onChange={(e) => {
                const v = e.currentTarget.value || "";
                setVersao(v);
              }}
            />
          </Label>
          <Label title="Data Prev Inicio *" className="col s12 m2 l2">
            <Input 
              type="date" 
              name="dataPrevInicio" 
              required="true" 
              defaultValue={dataPrevInicio}
              onBlur={(e) => {
                const v = e.currentTarget.value || "";
                setDataPrevInicio(v);
              }}
            />
          </Label>
          <Label title="Data Prev Entrega *" className="col s12 m2 l2">
            <Input 
              type="date" 
              name="dataPrevFinal" 
              required="true" 
              defaultValue={dataPrevFinal}
              onBlur={(e) => {
                const v = e.currentTarget.value || "";
                setDataPrevFinal(v);
              }}
            />
          </Label>
        </div>
        <div className="row no-margin">
          <div className="col s12 m12 l12">
            <AtividadesList setter={setAtividades} defaultData={atividadesProjeto || []} setterVersao={setVersao} clonaCronograma={clonaCronograma} />
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
